import ApiClient from './apiClient'
import {
  DedicatedServer,
  DedicatedServerCreate,
  DedicatedServerCreateOptions,
  DedicatedServerListResponse,
  DedicatedServerMetrics,
  DedicatedServerOperationResponse,
  DedicatedServerPowerAction,
  DedicatedServerReinstall,
  DedicatedServerUpdate,
  DedicatedServerMetricsPeriod,
  DedicatedServerPricePeriod,
} from './bareMetalTypes'

const serversUrl = 'dedicated-servers/servers'
const serverUrl = (id: string) => `${serversUrl}/${encodeURIComponent(id)}`

const bareMetalService = {
  getListMyServers: (params?: { page?: number; page_size?: number }) =>
    ApiClient.get<DedicatedServerListResponse>(serversUrl, { params }),
  createServiceOrder: () => ApiClient.post(`${serversUrl}/service-order`),
  getServerById: (id: string) => ApiClient.get<DedicatedServer>(serverUrl(id)),
  deleteServerById: (id: string) => ApiClient.delete<DedicatedServerOperationResponse>(serverUrl(id)),
  createServer: (data: DedicatedServerCreate) => ApiClient.post<DedicatedServerOperationResponse>(serversUrl, data),
  getCreateOptions: (params?: { period?: DedicatedServerPricePeriod }) =>
    ApiClient.get<DedicatedServerCreateOptions>(`${serversUrl}/create_options`, { params }),
  getPermissions: () => ApiClient.get(`${serversUrl}/permissions`),
  changePowerStatus: (id: string, status: DedicatedServerPowerAction) =>
    ApiClient.post<{ detail: string }>(`${serverUrl(id)}/${status}`),
  editServer: (id: string, data: DedicatedServerUpdate) => ApiClient.patch<DedicatedServer>(serverUrl(id), data),
  updateServer: (id: string, data: DedicatedServerUpdate) => ApiClient.put<DedicatedServer>(serverUrl(id), data),
  reinstallServer: (id: string, data: DedicatedServerReinstall) =>
    ApiClient.post<DedicatedServerOperationResponse>(`${serverUrl(id)}/reinstall`, data),
  getFreeIps: (id: string) =>
    ApiClient.get<{ ips: { id: number | null; ip: string }[] }>(`${serverUrl(id)}/floating-ip`),
  addFloating: (id: string, data: { ip: string }) => ApiClient.post<DedicatedServer>(`${serverUrl(id)}/floating-ip`, data),
  removeFloating: (id: string, data: { ip: string }) => ApiClient.delete<void>(`${serverUrl(id)}/floating-ip`, { data }),
  getLogs: (id: string) =>
    ApiClient.get<{ id: number; description: string; created_at: string }[]>(`${serverUrl(id)}/logs`),
  getConsoleUrl: (id: string) => ApiClient.get<{ token: string; access_url: string }>(`${serverUrl(id)}/console`),
  getMetrics: (id: string, data: { predefined: DedicatedServerMetricsPeriod }) =>
    ApiClient.post<DedicatedServerMetrics>(`${serverUrl(id)}/metrics`, data),
  getBreakDown: (id: string) => ApiClient.get<Record<string, unknown>>(`${serverUrl(id)}/network`),
}

export default bareMetalService
